import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Tailwind class'ları birleştir + conflict çöz */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
